<ng-container *ngIf="startRender">

  <mat-form-field appearance="outline" matTooltipPosition="above" [matTooltip]="formGroup.value.flatSearch? formGroup.value.flatSearch : 'Please search for a valid address'" [formGroup]="formGroup" *ngIf="!formGroup.get('isManualEntry').value">
    <mat-label>{{placeholderText}}</mat-label>
    <input matInput type="text" placeholder="{{placeholderText}}" aria-label="Address" [matAutocomplete]="auto"
      formControlName="flatSearch" [disabled]="readonly" tabindex="{{tabindex}}">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayText" (optionSelected)="updatedSelectedAddressRecord($event.option.value)">
      <mat-option (click)="toggleManualAddress(true)">
        <span style="text-decoration: underline;">Enter address manually</span>
      </mat-option>
      <mat-option (click)="toggleTbaAddress()" *ngIf="allowTba">
        <span style="text-decoration: underline;">TBA</span>
      </mat-option>
      <ng-container *ngIf="relatedAddresses && relatedAddresses.length > 0">
        <mat-option *ngFor="let address of relatedAddresses" [value]="address" (click)="selectRelatedAddress(address)">
          <span>{{ address?.Address?.addressText }}</span>
        </mat-option>
      </ng-container>
      <mat-option *ngFor="let address of filteredAddress" [value]="address">
        <span>{{ address.text }}</span>
      </mat-option>
    </mat-autocomplete>
    <mat-error>
      <label *ngIf="formGroup.get('flatSearch').hasError('required')">Please select a valid address.</label>
      <label *ngIf="!formGroup.get('flatSearch').hasError('required') && (formGroup.get('flatSearch').hasError('hasInvalidSiblingFormControl'))">Please select the address again as it appears to be invalid.</label>
    </mat-error>
  </mat-form-field>

  <div class="row pt-2 pb-3" *ngIf="formGroup.get('isManualEntry').value">
    <div class="col-sm-6">
      <strong>{{placeholderText}}</strong> - Please enter manually.
    </div>
    <div class="col-sm-6 text-end">
      <button mat-icon-button type="button" color="primary" (click)="toggleManualAddress(false)"><mat-icon>search</mat-icon></button>
    </div>
  </div>

  <ng-container *ngIf="formGroup.get('isManualEntry').value" [formGroup]="formGroup">
    <div *ngIf="allowPOBox" class="row">
      <div class="col-sm-12">
        <mat-checkbox formControlName="isPoBox">PO Box</mat-checkbox>
      </div>
    </div>
    <ng-container *ngIf="!formGroup.get('isPoBox').value">
      <div class="row">
        <div class="col-sm-4">
          <mat-form-field appearance="outline">
            <mat-label>Unit number</mat-label>
            <input matInput placeholder="Unit number" formControlName="unitNumber">
            <mat-error>
              <span *ngIf="formGroup.get('unitNumber')?.errors?.required">This field is required</span>
              <span *ngIf="formGroup.get('unitNumber')?.errors?.whitespace">The first character must not be a space.</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field appearance="outline">
            <mat-label>Street number</mat-label>
            <input matInput placeholder="Street number" formControlName="streetNumber">
            <mat-error>
              <span *ngIf="formGroup.get('streetNumber')?.errors?.required">This field is required</span>
              <span *ngIf="formGroup.get('streetNumber')?.errors?.whitespace">The first character must not be a space.</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field appearance="outline">
            <mat-label>Property name</mat-label>
            <input matInput placeholder="Property name" formControlName="propertyName">
            <mat-error>
              <span *ngIf="formGroup.get('propertyName')?.errors?.required">This field is required</span>
              <span *ngIf="formGroup.get('propertyName')?.errors?.whitespace">The first character must not be a space.</span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
    <div class="row">
      <ng-container *ngIf="!formGroup.get('isPoBox').value">
        <div class="col-sm-4">
          <mat-form-field appearance="outline">
            <mat-label>Street name</mat-label>
            <input matInput placeholder="Street name" formControlName="streetName">
            <mat-error>
              <span *ngIf="formGroup.get('streetName')?.errors?.required">This field is required</span>
              <span *ngIf="formGroup.get('streetName')?.errors?.whitespace">The first character must not be a space.</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field appearance="outline">
            <mat-label>Street type</mat-label>
            <input matInput placeholder="Street type" formControlName="streetTypeSearch" [matAutocomplete]="street" autocomplete="off">
            <mat-autocomplete #street="matAutocomplete" [displayWith]="displayStreetType" [panelWidth]="'500px'">
              <mat-option *ngFor="let streetType of filteredStreetTypes | async" [value]="streetType" (onSelectionChange)="updateSelectedStreet(streetType)">
                {{streetType.text}}
              </mat-option>
            </mat-autocomplete>
            <mat-error>
              <span *ngIf="formGroup.get('streetTypeSearch')?.errors?.required">This field is required</span>
              <span *ngIf="formGroup.get('streetTypeSearch')?.errors?.whitespace">The first character must not be a space.</span>
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>
      <ng-container *ngIf="formGroup.get('isPoBox').value">
        <div class="col-sm-8">
          <mat-form-field appearance="outline">
            <mat-label>PO Box</mat-label>
            <input matInput placeholder="PO Box" formControlName="poBox">
            <mat-error>
              <span *ngIf="formGroup.get('poBox')?.errors?.required">This field is required</span>
              <span *ngIf="formGroup.get('poBox')?.errors?.whitespace">The first character must not be a space.</span>
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>

      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Suburb</mat-label>
          <input matInput placeholder="Suburb" formControlName="suburb" [matAutocomplete]="suburb" autocomplete="off">
          <mat-autocomplete #suburb="matAutocomplete" (optionSelected)="updatedSelectedSuburb($event.option.value)" [panelWidth]="'500px'">
              <mat-option *ngFor="let suburb of filteredSuburbs" [value]="suburb" matTooltipPosition="above" [matTooltip]="suburb.name + ' : ' + suburb.postcode + ' - ' + suburb.state ">
                <span>{{ suburb.name }}</span> : <span>{{ suburb.postcode }} - {{ suburb.state }}</span>
              </mat-option>
          </mat-autocomplete>
          <mat-error>
            <span *ngIf="formGroup.get('suburb')?.errors?.required">This field is required</span>
            <span *ngIf="formGroup.get('suburb')?.errors?.whitespace">The first character must not be a space.</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>State</mat-label>
            <input matInput placeholder="State" formControlName="state" [matAutocomplete]="state" autocomplete="off" [readonly]="readonlyState">
            <mat-autocomplete #state="matAutocomplete" [panelWidth]="null">
              <mat-option *ngFor="let state of filteredStates" [value]="state.ext.Name">
                <span>{{ state.ext.Name }}</span>
              </mat-option>
            </mat-autocomplete>
            <mat-error>
              <span *ngIf="formGroup.get('state')?.errors?.required">This field is required</span>
              <span *ngIf="formGroup.get('state')?.errors?.whitespace">The first character must not be a space.</span>
            </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Postcode</mat-label>
          <input matInput placeholder="Postcode" formControlName="postcode" [readonly]="readonlyState">
          <mat-error *ngIf="formGroup.get('postcode')?.errors">
            <span *ngIf="formGroup.get('postcode')?.errors?.required">This field is required</span>
            <span *ngIf="formGroup.get('postcode')?.errors['not-cardinal']">Postcode is invalid</span>
            <span *ngIf="formGroup.get('postcode')?.errors['min-length']">Postcode is too short</span>
            <span *ngIf="formGroup.get('postcode')?.errors['max-length']">Postcode is too long</span>
            <span *ngIf="formGroup.get('postcode')?.errors?.whitespace">The first character must not be a space.</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Country</mat-label>
          <mat-select placeholder="Country" formControlName="country" (selectionChange)="updateSelectedCountry($event.value)" [panelWidth]="null">
            <mat-option *ngFor="let country of countries" [value]="country.id">{{country.text}}</mat-option>
          </mat-select>
          <mat-error>
            <span *ngIf="formGroup.get('formControlName')?.errors?.required">This field is required</span>
            <span *ngIf="formGroup.get('formControlName')?.errors?.whitespace">The first character must not be a space.</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="formGroup.hasError('streetTypeSet')">
      <div class="col-12">
        <span><mat-error>Please make sure a street type has been selected</mat-error></span>
      </div>
    </div>

    <div class="row" *ngIf="formGroup.hasError('stateTypeSet')">
      <div class="col-12">
        <span><mat-error>Please make sure a state has been selected</mat-error></span>
      </div>
    </div>
    <input hidden matInput placeholder="State ID" formControlName="stateId">
    <input hidden matInput placeholder="isManualEntry" formControlName="isManualEntry">
    <input hidden matInput placeholder="Address" formControlName="fullAddress" value={{fullAdress}}>
  </ng-container>
</ng-container>
